// Author Shi Wen Long
// Date 2021-11-22 15:34:19

class SithMesStoolProblematicPr {
    constructor({
                    id = null,
                    prId = '',
                    prCode = '',
                    prItem = '',
                    matCode = '',
                    matDesc = '',
                    problemDescription = '',
                    submitTime = '',
                    hopeFeedbackDate = '',
                    submitPerson = '',
                    engineer = '',
                    submitPersonName = '',
                    engineerName = '',
                    finishFlag = '',
                    problemReport = '',
                    remark = '',
                    problemReportList = '',

                }
                        = {}) {
        this.id = id;
        this.prId = prId;
        this.prCode = prCode;
        this.prItem = prItem;
        this.matCode = matCode;
        this.matDesc = matDesc;
        this.problemDescription = problemDescription;
        this.submitTime = submitTime;
        this.hopeFeedbackDate = hopeFeedbackDate;
        this.submitPerson = submitPerson;
        this.engineer = engineer;
        this.submitPersonName = submitPersonName;
        this.engineerName = engineerName;
        this.finishFlag = finishFlag;
        this.problemReport = problemReport;
        this.remark = remark;
        this.problemReportList = problemReportList;
    }
}

function newEntity() {
    return new SithMesStoolProblematicPr();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'problemPrType',
            label: 'label.sith.stool.sithMesStoolProblematicPr.filter.problemPrType',
            disabled: false,
            form: {
                type: 'dictEnumSelect',
                modalMultiSelectedType: 'string'
                ,entity: 'PROBLEM_PR_TYPE'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolProblematicPr.filter.projectCode',
            disabled: false,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.stool.sithMesStoolProblematicPr.filter.projectName',
            disabled: false,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.stool.sithMesStoolProblematicPr.filter.wbsNumber',
            disabled: false,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prId',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.prId',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prCode',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.prCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prItem',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.prItem',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'matCode',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.matCode',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
            }
        },
        {
            key: 'matDesc',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.matDesc',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'problemDescription',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.problemDescription',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'submitTime',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.submitTime',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'hopeFeedbackDate',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.hopeFeedbackDate',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'submitPerson',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.submitPerson',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'submitPersonName',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.submitPersonName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'engineer',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.engineer',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'engineerName',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.engineerName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'finishFlag',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.finishFlag',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    {
                        value: 'finished',
                        text: '完成'
                    },
                    {
                        value: 'not_finished',
                        text: '未完成'
                    }
                ]
            },
        },
        {
            key: 'problemReportList',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.problemReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolProblematicPr.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    prIdFilter: '',
    prCodeFilter: '',
    prItemFilter: '',
    matCodeFilter: '',
    matDescFilter: '',
    problemDescriptionFilter: '',
    submitTimeRteFilter: '',
    submitTimeLteFilter: '',
    hopeFeedbackDateRteFilter: '',
    hopeFeedbackDateLteFilter: '',
    submitPersonFilter: '',
    engineerFilter: '',
    finishFlagFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'problemPrTypeFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.problemPrType',
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            ,entity: 'PROBLEM_PR_TYPE'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumberFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.wbsNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prIdFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.prId',
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'prCodeFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.prCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'prItemFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.prItem',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'matCodeFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.matCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'matDescFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.matDesc',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'problemDescriptionFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.problemDescription',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'submitTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.submitTimeRte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'submitTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.submitTimeLte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'hopeFeedbackDateRteFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.hopeFeedbackDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'hopeFeedbackDateLteFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.hopeFeedbackDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'submitPersonFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.submitPerson',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'engineerFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.engineer',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'finishFlagFilter',
        label: 'label.sith.stool.sithMesStoolProblematicPr.filter.finishFlag',
        disabled: false,
        form: {
            type: 'input'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'prId',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.prId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'prCode',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.prCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'prItem',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.prItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'matCode',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.matCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'matDesc',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.matDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'problemDescription',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.problemDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'submitTime',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.submitTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'hopeFeedbackDate',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.hopeFeedbackDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'submitPerson',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.submitPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'engineer',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.engineer',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'finishFlag',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.finishFlag',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: [
                {
                    value: 'finished',
                    text: '完成'
                },
                {
                    value: 'not_finished',
                    text: '未完成'
                }
            ]
        },
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea'
        }
    },
    {
        key: 'problemReportList',
        label: 'label.sith.stool.sithMesStoolProblematicPr.entity.problemReport',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment'
            , correspondingField: 'problemReport'
        }
    }
]

export {
    SithMesStoolProblematicPr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
